// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".requiredRow:before {\n  content: \"*\";\n  color: red;\n  padding-right: 2px;\n}\nbody[data-sidebar=dark] .mm-active .active {\n  color: #b4c9de !important;\n  background-color: #707070;\n}\n.sub-menu .mm-active {\n  background-color: #707070;\n}", ""]);
// Exports
module.exports = exports;
